import { InfoTable, InfoTableRow } from "@myaccount/_components/info-table";
import { useI18n } from "@wojo/localization";
import { Text } from "@wojo/ui";
import {
    GcDepartureFragment,
    GroupMemberProspectDetailsFragment,
} from "generated/graphql";

export type MembersOverviewProps = {
    gcDeparture: Partial<GcDepartureFragment>;
    gcDepartureProspects: GroupMemberProspectDetailsFragment[];
    hasExtension: boolean;
};

export const MembersOverview: React.FC<MembersOverviewProps> = (props) => {
    const { gcDeparture, gcDepartureProspects, hasExtension } = props;
    const i18n = useI18n("account").account.myGroupMembers.membersOverview;

    if (!gcDeparture.departure) {
        return null;
    }

    return (
        <InfoTable aria-label={i18n.heading.l()}>
            <InfoTableRow header={i18n.bookedOnTourLabel.l()}>
                <Text.Body emphasis="1">
                    {gcDeparture.nbTravelersConfirmed || 0}
                </Text.Body>
            </InfoTableRow>
            {hasExtension && (
                <InfoTableRow header={i18n.bookedOnExtensionLabel.l()}>
                    <Text.Body emphasis="1">
                        {gcDeparture.nbTravelersWithExtension || 0}
                    </Text.Body>
                </InfoTableRow>
            )}
            <InfoTableRow header={i18n.spotsLeftLabel.l()}>
                <Text.Body emphasis="1">
                    {gcDeparture.departure.nbSpotsLeft || 0}
                </Text.Body>
            </InfoTableRow>
            <InfoTableRow header={i18n.interestedTravelersLabel.l()}>
                <Text.Body emphasis="1">
                    {gcDepartureProspects.length || 0}
                </Text.Body>
            </InfoTableRow>
            <InfoTableRow
                header={i18n.canceledTravelersLabel.l()}
                hideSeparator={true}
            >
                <Text.Body emphasis="1">
                    {gcDeparture.nbTravelersCancelled || 0}
                </Text.Body>
            </InfoTableRow>
        </InfoTable>
    );
};
